"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Connection = /** @class */ (function () {
    function Connection(from, to) {
        this.from = from;
        this.to = to;
        this.from = from;
        this.to = to;
        this.weight = Math.random();
        this.change = 0;
    }
    Connection.prototype.toJSON = function () {
        return {
            change: this.change,
            weight: this.weight,
            from: this.from.id,
            to: this.to.id
        };
    };
    Connection.prototype.setWeight = function (w) {
        this.weight = w;
    };
    Connection.prototype.setChange = function (val) {
        this.change = val;
    };
    return Connection;
}());
exports.default = Connection;
